import proptypes from 'prop-types';

const { number, shape } = proptypes;

export const Point = shape({
  x: number.isRequired,
  y: number.isRequired
});